module.exports = __webpack_public_path__ + "img/goChain.b0b17a06.png";